import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractTableToolsService } from './abstract-table-tools.service';

export interface ICallParams {
    tipo?: 'json';
    class?: string;
    accion: string;
    [property: string]: any;
}

export interface IPsResponseFormat {
    datos: any[];
    error: {
        codigo: string;
        texto: string|string[];
    };
}

@Injectable()
export abstract class AbstractTableToolsPsFormarService extends AbstractTableToolsService {
    protected abstract _class_name: string;
    protected abstract _inc_json: string;
    private readonly _common_endpoint = 'php/ajax/ajax.php';

    constructor(protected injectorPs: Injector) {
        super(injectorPs);
    }
    
    // ---------------------------------------------------------------------------
    protected _getDefaultParams(endpoint: string, data?: any): ICallParams {
        const call_params: ICallParams = {
            tipo: 'json',
            class: this._class_name,
            accion: endpoint,
            inc_json: this._inc_json,
            argumentos: typeof data !== 'string' ? JSON.stringify(data) : data,
        };
        
        if (typeof data !== 'string' && data?.id) {
            call_params['id'] = data.id;
        }
        
        return call_params;
    }

    // -------------------------------------------------------------------------
    public override requestToServerGet(endpoint: string, filters?: object | null): Observable<any> {
        const dataToSend = this._getDefaultParams(endpoint, filters);
        return super.requestToServerGet(this._common_endpoint, dataToSend);
    }

    // -------------------------------------------------------------------------
    public override requestToServerPost(endpoint: string, filters?: object | null): Observable<any> {
        const dataToSend = this._getDefaultParams(endpoint, filters);
        return super.requestToServerPost(this._common_endpoint, dataToSend);
    }

    // -------------------------------------------------------------------------
    public override requestToServerPostJSON(endpoint: string, filters?: object | string | number | null): Observable<any> {
        const dataToSend = this._getDefaultParams(endpoint, filters);
        return super.requestToServerPostJSON(this._common_endpoint, dataToSend);
    }

    // -------------------------------------------------------------------------
    public override sendToServerJSON(endpoint: string, filters?: object | string | null): Observable<any> {
        const dataToSend = this._getDefaultParams(endpoint, filters);
        return super.sendToServerJSON(this._common_endpoint, dataToSend);
    }
}